import React, { Component } from 'react'
import {connect} from 'react-redux';
import withAppShell from '../../../hoc/withAppShell/WithAppShell';
import {Grades} from '.';
import {AddGradeActions} from '../../../../store'

class EditGradesContainer extends Component {

    constructor(props){
          super(props)  
          this.state={
           activeSchool : props.activeSchool,
            errors : [""]
          };
        }
        componentWillMount(){
            this.props.getGradeMasterData();
            this.props.getGrades(1,1);
          }
       

    render() {
         
       return  <Grades {...this.props}/>
    }
}

const mapDispatchToProps = (dispatch) => ({
    getGrades: (owenerId,schoolId) => dispatch(AddGradeActions.getGrades(owenerId,schoolId)),
    getGradeMasterData:() => dispatch(AddGradeActions.getGradeMasterData()),
    saveGradeInformation: (schoolId,data)=> dispatch(AddGradeActions.saveGradeInformation(schoolId,data)),
}
)
const mapStateToProps = (state, ownProps) => {
    return {
        gradeMasterData:state.gradeInformation.gradeList,
        gradelist:state.gradeInformation.gradesList,
        getGradesInProgress: state.gradeInformation.getGradesInProgress,
        getGradeMasterDataInProgress:state.gradeInformation.getGradeMasterDataInProgress
    }
}

export default connect (mapStateToProps , mapDispatchToProps) (withAppShell(EditGradesContainer))
